import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface IMenuItem {
  id: number
  title: string
  svgId: string
  route: string
  type: string
  order: number
  active:boolean
  subMenu: SubMenu[]
}
export interface SubMenu {
  id: number
  title: string
  svgId: string
  route: string
  type: string
  order: number
  subMenu: any[]
}

interface ISidebarState {
  sidenavOpen?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  public sidebarState: ISidebarState = {
    sidenavOpen: true,
  };

  defaultMenu: IMenuItem[] = [
    // {
    //   title: 'entities',
    //   type: 'link',
    //   icon: `complaints-form-builder-icon`,
    //   state: '/admin/entities'
    // },
    // {
    //   title: 'Complaint Forms',
    //   type: 'link',
    //   icon: `complaints-form-builder-icon`,
    //   state: '/admin/complaintForms'
    // },
    // {
    //   title: 'categories',
    //   type: 'dropDown',
    //   icon: `complaints-form-builder-icon`,
    //   state: '/admin/categories',
    //   sub: [
    //     { title: 'mainCategories', state: '/admin/categories/main', type: 'link' },
    //     { title: 'subcategories', state: '/admin/categories/sub', type: 'link' },
    //   ]
    // },
    // {
    //   title: 'Warehouses',
    //   type: 'dropDown',
    //   icon: `
    //   <svg width="24.995" height="21" viewBox="0 0 24.995 21">
    //     <g id="Icons" transform="translate(-73.152 -339.999)">
    //       <g id="restaurant-branches-inactive-ic" transform="translate(61.648)">
    //         <path id="Union_60" data-name="Union 60" d="M3.154,21A3.151,3.151,0,0,1,0,17.856V8.687A3.116,3.116,0,0,1,1.051,6.32L7.362.8a3.174,3.174,0,0,1,4.211,0L17.885,6.32a3.155,3.155,0,0,1,1.053,2.359v9.176A3.153,3.153,0,0,1,15.781,21Zm12.627-2.1a1.051,1.051,0,0,0,1.053-1.045V8.679a1.075,1.075,0,0,0-.361-.79l-6.309-5.5a1.057,1.057,0,0,0-1.393,0l-6.312,5.5a1.064,1.064,0,0,0-.357.79v9.176A1.047,1.047,0,0,0,3.154,18.9h2.1V13.708a3.141,3.141,0,0,1,3.16-3.124h2.1a3.139,3.139,0,0,1,3.154,3.124V18.9Zm-4.209,0V13.708a1.048,1.048,0,0,0-1.053-1.042h-2.1a1.047,1.047,0,0,0-1.055,1.042V18.9Z" transform="translate(11.504 340)" fill="#38455d"/>
    //         <path id="Subtraction_59" data-name="Subtraction 59" d="M8.586,21H4.051a3.157,3.157,0,0,0,2.965-2.1h1.57a1.053,1.053,0,0,0,1.055-1.05V8.676a1.065,1.065,0,0,0-.361-.785l-6.311-5.5a1.054,1.054,0,0,0-1.355-.028L0,.95.168.8A3.158,3.158,0,0,1,4.377.8L10.691,6.32a3.151,3.151,0,0,1,1.053,2.356v9.176A3.157,3.157,0,0,1,8.586,21Z" transform="translate(24.755 339.999)" fill="#888f9e"/>
    //       </g>
    //     </g>
    //   </svg>`,
    //   state: '/admin/warehouses',
    //   sub: [
    //     { title: 'Warehouses list', state: '/admin/warehouses/list', type: 'link' },
    //     { title: 'Warehouses Transactions', state: '/admin/warehouses/transactions', type: 'link' },
    //     { title: 'Ingredients storage unit', state: '/admin/warehouses/ingredients', type: 'link' },
    //     { title: 'Warehouse Stock', state: '/admin/warehouses/stock', type: 'link' },
    //     { title: 'Purchase Request', state: '/admin/warehouses/parchaseRequest', type: 'link' },
    //     { title: 'Need Stock Request', state: '/admin/warehouses/needStock', type: 'link' },
    //     { title: 'Send Stock Request', state: '/admin/warehouses/sendStock', type: 'link' },
    //     { title: 'Inventory Adjustment', state: '/admin/warehouses/invAdjustment', type: 'link' },
    //     { title: 'Cost Adjustment', state: '/admin/warehouses/costAdjustment', type: 'link' },
    //     { title: 'Convert to Ingredients Stock', state: '/admin/warehouses/convertIngr', type: 'link' },
    //   ]
    // },
  ];

  // sets iconMenu as default;
  menuItems = new BehaviorSubject<IMenuItem[]>(this.defaultMenu);
  // navigation component has subscribed to this Observable
  // menuItems$ = this.menuItems.asObservable();

  constructor() { }
}
